import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { titleStoryStyleCardTitleArticle$key } from "~/queries/__generated__/titleStoryStyleCardTitleArticle.graphql";

import { CardTitleContainer, CardTitleWord } from "./styles";

export type Props = {
  reference: titleStoryStyleCardTitleArticle$key;
};

export const StoryStyleCardTitle: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const cardTitle = useFragment(
    graphql`
      fragment titleStoryStyleCardTitleArticle on Article {
        socialHeadline
      }
    `,
    reference_,
  );
  return (
    <CardTitleContainer>
      <CardTitleWord>{cardTitle.socialHeadline}</CardTitleWord>
    </CardTitleContainer>
  );
};

StoryStyleCardTitle.displayName = "StoryStyleCardTitle";
